import React from "react";
import { Nav } from "shards-react";
import SidebarNavItem from "./SidebarNavItem";
import PropTypes from "prop-types";

class SidebarNavItems extends React.Component {
    static propTypes = {
        sidebarNavItems: PropTypes.any,
        pageNumber: PropTypes.string
    };

    render() {
        const { sidebarNavItems: items, pageNumber, children } = this.props;
        return (
            <div
                className="nav-wrapper"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                }}
            >
                <div>
                    {process.env.REACT_APP_ENV_ALERT ? (
                        <div
                            style={{
                                backgroundColor:
                                    process.env.REACT_APP_ENV_ALERT ===
                                    "Desenvolvimento"
                                        ? "#900"
                                        : "#B50",
                                color: "#fff",
                                textAlign: "center",
                                paddingTop: 10,
                                paddingBottom: 10
                            }}
                        >
                            {process.env.REACT_APP_ENV_ALERT}
                        </div>
                    ) : null}
                    <Nav className="nav--no-borders flex-column">
                        {items.map((item, idx) => (
                            <SidebarNavItem
                                key={idx}
                                item={item}
                                pageNumber={pageNumber}
                            />
                        ))}
                    </Nav>
                </div>
                {children}
            </div>
        );
    }
}

export default SidebarNavItems;
